// Shared date/duration formatters for the admin pages - previously
// each page (Users, User Details, Meetings, Meeting Details, Audit,
// Dashboard) reimplemented its own near-identical copy (Task 10
// review). `fallback` is a parameter (not a hardcoded default per
// call site) so every existing page keeps its exact prior output for
// missing values ('—' in most places, '0 min' in a couple of stat
// cards) - this is a pure dedup, not a behavior change.

export function formatAdminDate(isoString, fallback = '—') {
  if (!isoString) return fallback;
  return new Date(isoString).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatAdminDateTime(isoString, fallback = '—') {
  if (!isoString) return fallback;
  return new Date(isoString).toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatAdminDuration(seconds, fallback = '—') {
  if (!seconds) return fallback;
  return `${Math.round(seconds / 60)} min`;
}

// An AI answer time, from whole milliseconds. Anything that is not a
// positive number is "no valid measurement" and shows the fallback - never
// "0.00 s", which would read as an instant answer.
export function formatAdminAnswerTime(ms, fallback = '—') {
  if (typeof ms !== 'number' || !Number.isFinite(ms) || ms <= 0) return fallback;
  return `${(ms / 1000).toFixed(2)} s`;
}

// Average only: zero saved responses is different from missing measurements.
// Keep the shared positive-duration formatter unchanged for fastest/slowest.
export function formatAdminAverageAnswerTime(ms, responseCount) {
  if (responseCount === 0) return '0.00 s';
  return formatAdminAnswerTime(ms);
}
